import WorkSpaceLoading from '../loading/workSpaceLoading';
import { rootStore } from '../../mobx/rootStore';
import { observer } from 'mobx-react-lite';
import { MainSection } from '../appLayout/styles';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { excludedTabBar } from '../../helpers/common';

interface Props {
  children?: React.ReactNode;
}

const LayoutWithoutNavbar: React.FC<Props> = (props) => {
  const { children } = props;
  // Mobx store
  const { appStore } = rootStore || {};
  const { isAppLoading, isTabBarLoad, extractedDesktopView, isNavbarShow } = appStore || {};

  // other variables
  const location = useLocation();

  const excludeTabs = useMemo(() => {
    return excludedTabBar(location.pathname);
  }, [location.pathname]);

  const mainSectionClassName = useMemo(() => {
    return [
      'main-section',
      !isNavbarShow && extractedDesktopView && 'navbar-extracted-hidden',
      extractedDesktopView ? 'extracted-desktop-diff-padding' : 'extracted-desktop-hidden',
      !isNavbarShow ? 'main-navbar-hidden' : 'main-navbar-show',
      (!isTabBarLoad || excludeTabs) && 'tabbar-not-load'
    ]
      .filter(Boolean)
      .join(' ');
  }, [isNavbarShow, extractedDesktopView, isTabBarLoad, excludeTabs]);

  return (
    <>
      {isAppLoading ? (
        <MainSection className={mainSectionClassName}>
          <WorkSpaceLoading />
        </MainSection>
      ) : (
        children
      )}
    </>
  );
};

export default observer(LayoutWithoutNavbar);
